import dayLight from "@/themes/light/day";
import sharedDark from "@/themes/dark";

export default {
  light: { ...dayLight },
  dark: { ...sharedDark },
};
